<template>
    <el-table :data="authListData" row-key="id" v-loading="loading" empty-text="暂无可用公章或合同章">
        <el-table-column width="50">
          <template slot-scope="scope">
            <el-radio
              v-model="currentRow"
              :label="scope.row.sealId"
              class="radio-hide-label"
            >
            </el-radio>
          </template>
        </el-table-column>

        <el-table-column prop="sealId" label="印章ID"></el-table-column>
        <el-table-column prop="sealName" label="印章名称"></el-table-column>
        <el-table-column prop="sealTypeName" label="印章类型"></el-table-column>
        <el-table-column prop="sealImage" label="印章图片">
          <template slot-scope="scope">
            <el-popover placement="right" trigger="hover">
              <img :src="scope.row.sealImage" style="max-width: 300px; max-height: 300px;" />
              <img :src="scope.row.sealImage" slot="reference" style="width: 50px; height: 50px;" />
            </el-popover>
          </template>
        </el-table-column>
    </el-table>
</template>

<script>
import { getContractOrgSealList, getContractOrgSealAuth } from '@/api/domain/organize'

export default {
  name: 'sealAuthList',
  props: {
    orgId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      authListData: [],
      currentRow: 0,
      loading: false,
    }
  },
  methods: {
    async getSealList() {
      this.loading = true
      const { code, data = [] } = await getContractOrgSealList({
        orgId: this.orgId,
      })
      this.loading = false
      if (code === 1) {
        this.authListData = data
        // 只有一个印章时选中，其他情况不选中
        if (data.length === 1) {
          this.currentRow = data[0].sealId
        }
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    async sealAuthSubmit() {
      if (this.currentRow === 0) {
        this.$message.error('请选择印章后重试')
        return
      }
      const { code } = await getContractOrgSealAuth({
        sealId: this.currentRow,
        orgId: this.orgId,
      })
      if (code === 1) {
        this.$emit('sealAuthSubmitSucc')
      }
    },
  },
  created() {
    this.getSealList()
  },
}
</script>

<style lang="scss" scoped>
.radio-hide-label {
  ::v-deep .el-radio__label {
    display: none;
  }
}
</style>
</script>
